module.exports = __webpack_public_path__ + "static/media/ic-lock.c8a0f312.svg";